<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DPhoneEditor',
  extends: compoment
}
</script>
